module.exports = __webpack_public_path__ + "static/media/dave.10b705e5.svg";